import Modal from 'components/Modal';
import Overlay from 'components/Overlay';
import TextOverlay from 'components/TextOverlay';
import VideoOverlay from 'components/VideoOverlay';
import { VIEW } from 'helper/js/constants';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

type OverlayContainerState = {
  close: boolean;
};

type OverlayContainerProps = {
  close: boolean;
  video?: AVideoData;
  text?: string;
  handleClose: () => void;
  showOverlay: boolean;
  currentView: string;
  contentId: string;
};

class OverlayContainer extends PureComponent<OverlayContainerProps, OverlayContainerState> {
  constructor(props: OverlayContainerProps) {
    super(props);
    this.state = {
      close: false,
    };
  }

  handleClose = () => {
    this.props.handleClose();
  };

  getContent = () => {
    if (this.props.video) {
      const { embedFragment, videoProvider } = this.props.video;
      return <VideoOverlay videoProvider={videoProvider} embedFragment={embedFragment} />;
    }
    if (this.props.text) {
      return <TextOverlay text={this.props.text} />;
    }
    return null;
  };

  render() {
    return (
      this.props.showOverlay && (
        <Modal>
          <Overlay onClose={this.handleClose}>{this.getContent()}</Overlay>
        </Modal>
      )
    );
  }
}
const mapStateToProps = (state: AppState, props: OverlayContainerProps) => {
  const { show } = state.ageRestriction;
  const { currentView, contentId } = props;
  const { videos, texts, pages } = state.appData;
  const video = currentView === VIEW.VIDEO && contentId ? videos[contentId] : undefined;
  let text = currentView === VIEW.TEXT && contentId ? texts[contentId] : undefined;

  if (!text && currentView === VIEW.TEXT && contentId && pages) {
    for (const page of pages) {
      const link = page.links?.find((l) => l.id === contentId);
      if (link) {
        text = link.text || (link as any).description;
        break;
      }
    }
  }

  return {
    showOverlay: !show && Boolean(video || text),
    video,
    text,
  };
};

export default compose<any>(connect(mapStateToProps))(OverlayContainer);
